export const CATEGORIES = [
  { value: "church_workshop", label: "Church Workshop", short: "Church Workshop" },
  { value: "protect_his_house", label: "Protect His House", short: "Protect His House" },
  { value: "concealed_carry", label: "Concealed Carry Class", short: "CCW Class" },
  { value: "table_event", label: "Table Events", short: "Table" },
  { value: "shoot_sig", label: "SHOOT SIG Event", short: "SHOOT SIG" },
];

export const STATES = [
  { value: "virginia", label: "Virginia", abbr: "VA" },
  { value: "west_virginia", label: "West Virginia", abbr: "WV" },
  { value: "maryland", label: "Maryland", abbr: "MD" },
  { value: "pennsylvania", label: "Pennsylvania", abbr: "PA" },
  { value: "delaware", label: "Delaware", abbr: "DE" },
];

export const CATEGORY_MAP = CATEGORIES.reduce((acc, c) => {
  acc[c.value] = c;
  return acc;
}, {});

export const STATE_MAP = STATES.reduce((acc, s) => {
  acc[s.value] = s;
  return acc;
}, {});

export function categoryLabel(value) {
  return CATEGORY_MAP[value]?.label || value;
}

export function stateLabel(value) {
  return STATE_MAP[value]?.label || value;
}

export function stateAbbr(value) {
  return STATE_MAP[value]?.abbr || value;
}

export function formatEventDate(iso) {
  try {
    const d = new Date(iso + "T00:00:00");
    return d.toLocaleDateString("en-US", {
      weekday: "short",
      month: "short",
      day: "numeric",
      year: "numeric",
    });
  } catch {
    return iso;
  }
}
